module.exports = __webpack_public_path__ + "img/hosting-solutions.daf8607b.png";